<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <div class="header-block">
                    <div class="header-title">
                        <app-breadcrumb></app-breadcrumb>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off">
                                <input [ngModelOptions]="{standalone: true}" placeholder="search user"
                                    [(ngModel)]="searchUser" />
                            </form>
                            <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchUser != ''"></i>
                            <i class="bi bi-search"></i>
                        </div>
                        <div class="filter-icon">
                            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                        </div>
                    </div>
                </div>

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 20%;">{{ 'users.userName' | translate }}</th>
                            <th style="width: 20%;">{{ 'users.userMobileNo' | translate }}</th>
                            <th style="width: 20%;">{{ 'users.userEmail' | translate }}</th>
                            <th style="width: 15%;">{{ 'users.userType' | translate }}</th>
                            <th style="width: 15%;">{{ 'users.role' | translate }}</th>
                            <th style="width: 10%;">{{ 'generic.action' | translate }}</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let user of users | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        }; let i = index">

                        <p style="width: 20%;">{{user.userName}}</p>
                        <p style="width: 20%;" title="{{user.userMobileNo}}">{{user.userMobileNo}}</p>
                        <p style="width: 20%;" title="{{user.userEmail}}">{{user.userEmail}} </p>
                        <p style="width: 15%;">{{user.userType}}</p>
                        <p style="width: 15%;">
                            <span>
                                <button class="role-b"
                                    (click)="userSelected(user); getUserRoleByUserMobileAndCidWithCid(user.userMobileNo, user.cid)"
                                    data-toggle="modal" data-target="#addRole">
                                    <span *ngIf="user.roleSet && user.roleSet.length != 0">{{user.roleName}}</span>
                                    <span *ngIf="!user.roleSet || user.roleSet.length == 0">Add Role</span>
                                </button>
                            </span>
                        </p>
                        <p class="action-buttons" style="width: 10%">


                            <i (click)="getUserById(user.userId, user.cid)" data-toggle="modal"
                                data-target="#userDataView" class="bi bi-eye-fill"></i>
                            <i class="bi bi-pencil-square" (click)="getUserById(user.userId, user.cid)"
                                data-toggle="modal" data-target="#updateModal"></i>
                            <i class="bi bi-shield-lock" title="Register OTP" data-toggle="modal"
                                data-target="#passwordPromptModal" (click)="openTpmModal(user)"></i>
                            <!-- <i (click)="selectDelete(user.id,user)" data-toggle="modal" data-target="#deleteModal"
                                class="bi bi-trash3"></i> -->

                        </p>
                    </div>
                </div>

                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>

                <div class="loader" *ngIf="!isLoading && users.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                </div>

                <div class="paginator" *ngIf="paginatorVisible">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="recordsPerPage"
                        [totalRecords]="totalRecords" [showFirstLastIcon]="true" [showCurrentPageReport]="true"
                        [showPageLinks]="true" [showJumpToPageDropdown]="false"
                        currentPageReportTemplate="{first} - {last} of {totalRecords}">
                    </p-paginator>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="userDataView" tabindex="-1" role="dialog" aria-labelledby="productView" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'users.headings.detail' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="product-block" *ngFor="let data of userData">
                <div class="product-content">
                    <div class="product-details">
                        <div class="row product-form-details">
                            <div class="col-md-4 col-lg-4 product-form">
                                <label for="">{{ 'users.userName' | translate }}</label>
                                <p title="{{data.userName}}">{{data.userName || ' -- '}}</p>
                            </div>
                            <div class="col-md-4 col-lg-4 product-form">
                                <label for="">{{ 'users.userEmail' | translate }}</label>
                                <p>{{data.userEmail || ' -- '}}</p>
                            </div>
                            <div class="col-md-4 col-lg-4 product-form">
                                <label for="">{{ 'users.userMobileNo' | translate }}</label>
                                <p>{{data.userMobileNo || ' -- '}}</p>
                            </div>
                            <div class="col-md-4 col-lg-4 product-form">
                                <label for="">{{ 'users.userType' | translate }}</label>
                                <p>{{data.userType || ' -- '}}</p>
                            </div>
                            <div class="col-md-4 col-lg-4 product-form">
                                <label for="">{{ 'users.authMode' | translate }}</label>
                                <p>{{data.authMode || ' -- '}}</p>
                            </div>
                            <div class="col-md-4 col-lg-4 product-form">
                                <label for="">{{ 'users.branchId' | translate }}</label>
                                <p>{{data.branchId || ' -- '}}</p>
                            </div>
                            <!-- <div class="col-md-4 col-lg-4 product-form">
                        <label for="">Branch Id</label>
                        <p>{{data.branchId || ' -- '}}</p>
                    </div> -->
                            <div class="col-md-4 col-lg-4 product-form">
                                <label for="">{{ 'users.isVerified' | translate }}</label>
                                <p>{{data.isVerified || ' -- '}}</p>
                            </div>
                            <div class="col-md-4 col-lg-4 product-form">
                                <label for="">{{ 'users.reportsTo' | translate }}</label>
                                <p>{{data.reportsTo || ' -- '}}</p>
                            </div>
                            <div class="col-md-4 col-lg-4 product-form">
                                <label for="">{{ 'users.roleId' | translate }}</label>
                                <p *ngIf="data.roleId != null && data.roleId.length != 0">{{data.roleId}}</p>
                                <p *ngIf="data.roleId == null || data.roleId.length == 0"> -- </p>
                            </div>
                            <div class="col-md-4 col-lg-4 product-form">
                                <label for="">{{ 'users.roleName' | translate }}</label>
                                <p *ngIf="data.roleName != null && data.roleName.length != 0">{{data.roleName}}</p>
                                <p *ngIf="data.roleName == null || data.roleName.length == 0"> -- </p>
                            </div>
                        </div>

                        <p class="product-title" *ngIf="data.imageURL != null && data.imageURL != ''">Image:</p>
                        <div class="product-image-list" *ngIf="data.imageURL != null && data.imageURL != ''">
                            <div class="image-list">
                                <img src="{{data.imageURL}}" alt="">
                            </div>
                        </div>

                        <p class="product-title" *ngIf="data.userParameters != null && data.userParameters.length != 0">
                            {{ 'users.userParameters' | translate }} :</p>
                        <div class="product-key-value-list"
                            *ngIf="data.userParameters != null && data.userParameters.length != 0">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ 'users.ParamName' | translate }} </th>
                                        <th scope="col">{{ 'users.ParamValue' | translate }} </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let keyValueList of data.userParameters;let i = index">
                                        <th scope="col">{{keyValueList.key}}</th>
                                        <th scope="col">{{keyValueList.value || ' -- '}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton" (click)="cancelModel()" class="btn btn-secondary"
                        data-dismiss="modal" class="btn btn-secondary">{{ 'generic.cancel' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"> Edit Business Owner
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="editForm">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.userName' | translate }}</label>
                                <input formControlName="userName" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.userMobileNo' | translate }}</label>
                                <input readonly formControlName="userMobileNo" type="number"
                                    class="form-control no-edit">
                            </div>

                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.userEmail' | translate }}</label>
                                <input formControlName="userEmail" type="email" class="form-control">
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.userType' | translate }}</label>
                                <!-- <input formControlName="userType" type="text" class="form-control"> -->
                                <select name="" id="" formControlName="userType" class="form-control">
                                    <option value="{{type}}" *ngFor="let type of userTypes">{{type}}</option>
                                </select>
                            </div>


                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.dashboard' | translate }} <span class="required-field">*</span></label>
                                <ng-multiselect-dropdown [placeholder]="'Select Dashboard'"
                                    [settings]="dashboardDropdownSettings" [data]="dashboardList"
                                    [(ngModel)]="dashboardSelectedList" class="form-control"
                                    style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                                    (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.location' | translate }} <span class="required-field">*</span></label>
                                <ng-multiselect-dropdown [placeholder]="'Select Location'"
                                    [settings]="locationDropdownSettings" [data]="locationList"
                                    [(ngModel)]="locationSelectedList" class="form-control"
                                    style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                                    (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.group' | translate }} <span class="required-field">*</span></label>
                                <ng-multiselect-dropdown [placeholder]="'Select Group'"
                                    [settings]="objectGroupDataDropdownSettings" [data]="objectGroupData"
                                    [(ngModel)]="objectGroupDataSelectedList" class="form-control"
                                    style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                                    (onSelect)="onGroupSelect($event)" (onSelectAll)="onGroupSelectAll($event)"
                                    (onDeSelect)="onGroupDeSelect($event)" (onDeSelectAll)="onGroupDeSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.branch' | translate }} <span class="required-field">*</span></label>
                                <ng-multiselect-dropdown [placeholder]="'Select Branch'"
                                    [settings]="branchDropdownSettings" [data]="branchList"
                                    [(ngModel)]="branchSelectedList" class="form-control"
                                    style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                                    (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.department' | translate }} <span
                                        class="required-field">*</span></label>
                                <ng-multiselect-dropdown [placeholder]="'Select Department'"
                                    [settings]="departmentDropdownSettings" [data]="departmentList"
                                    [(ngModel)]="departmentSelectedList" class="form-control"
                                    style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                                    (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>



                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.reportsTo' | translate }}</label>
                                <select name="" id="" formControlName="reportsTo" class="form-control">
                                    <option value="" disabled selected hidden>--- Select Type ---</option>
                                    <option *ngFor="let user of usersWithoutCustomers" [value]="user.userId">
                                        {{user.userName}}</option>
                                </select>
                            </div>
                        </div>

                        <!-- <div class="col-lg-6 col-md-6 col-sm-12" >
                            <div class="form-group">
                                <label>{{ 'users.location' | translate }}</label>
                            
                                <select name="" id="" formControlName="location" class="form-control">
                                    <option value="" selected disabled> -- select location --</option>
                                    <option value="{{list.city}}" *ngFor="let list of locationList">{{list.city}} - {{list.postalCode}}</option>
                                </select>
                            </div>
                        </div> -->

                        <div *ngFor="let list of userParams">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label>{{list.name}}</label>
                                    <input *ngIf="list.boxType == 'Input'" [ngModelOptions]="{standalone: true}"
                                        type="text" [(ngModel)]="list.value" class="form-control">
                                    <select name="" id="" *ngIf="list.boxType == 'Dropdown'"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value"
                                        class="form-control">
                                        <option value="" disabled selected hidden>--- Select ---</option>
                                        <option *ngFor="let dropdownList of list.possibleValue" [value]="dropdownList">
                                            {{dropdownList}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>






                </div>
                <div class="modal-footer">
                    <button type="button" id="editCloseModal" (click)="clearData()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="updateUser()" class="btn btn-primary">{{ 'generic.save' | translate
                        }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i data-dismiss="modal" (click)="cancelModel()" class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" (click)="cancelModel()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" class="btn btn-primary" (click)="deleteUser()">{{ 'generic.delete' | translate
                        }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="addRole" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'users.headings.addRole' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="deleteClose()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">

                <div class="roles-block" *ngIf="roleList.length != 0">
                    <div class="role-header">
                        <h5>{{ 'users.roles' | translate }}</h5>
                    </div>
                    <div class="list">
                        <p [ngClass]="{ 'selected': list.isSelected }" *ngFor="let list of roleList">{{list.roleName}}
                        </p>
                    </div>

                    <!-- <div class="role-delete-block" *ngIf="isShowDelete">
                        <button type="button" class="btn btn-secondary" (click)="deleteClose()">{{ 'generic.cancel' |
                            translate }}</button>
                        <button type="button" class="btn btn-danger" (click)="deleteUserRole()">{{ 'generic.delete' |
                            translate }}</button>

                    </div> -->

                </div>


                <div class="form-group">
                    <div>
                        <label>{{ 'users.selectRole' | translate }}</label>
                        <!-- <select name="" id="" class="form-control" (change)="getSingleRoleById(selectedRoleId)" [(ngModel)]="selectedRoleId">
                            <option value="" selected disabled> -- select role -- </option>
                            <option [value]="role.roleId" *ngFor="let role of roles">{{role.roleName}}</option>
                        </select> -->
                        <ng-multiselect-dropdown [placeholder]="'Select Roles'" [settings]="rolesDropdownSettings"
                            [data]="rolesList" [(ngModel)]="rolesSelectedList" class="form-control"
                            style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                            (onSelect)="onRoleItemSelect($event)" (onSelectAll)="onRoleSelectAll($event)"
                            (onDeSelect)="onRoleDeSelect($event)" (onDeSelectAll)="onRoleDeSelectAll($event)">
                        </ng-multiselect-dropdown>
                    </div>

                    <div class="row" *ngFor="let role of selectedRoleData;let r = index">

                        <div class="col-md-12 col-lg-12" *ngFor="let screenList of role.screenGroupList;let i = index">
                            <div class="singleData">
                                <div class="single-role-header">
                                    <input type="checkbox" (click)="isChecked($event, r, i)"
                                        [checked]="screenList.isChecked">
                                    <label>{{screenList.groupName}}</label>
                                </div>
                                <div class="single-role-table">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style="width: 5%; padding-top: 10px; padding-bottom: 10px;">
                                                    <!-- <input type="checkbox" (click)="isChecked($event, r, i)"
                                                        [checked]="screenList.isChecked"> -->
                                                </th>
                                                <th style="width: 25%; padding-top: 10px; padding-bottom: 10px;">Name
                                                </th>
                                                <th style="width: 35%; padding-top: 10px; padding-bottom: 10px;">
                                                    Description</th>
                                                <th style="width: 40%; padding-top: 10px; padding-bottom: 10px;">
                                                    Permissions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                *ngFor="let screenPrivilegeList of screenList.screenPrivilegeList;let j = index">
                                                <th><input type="checkbox" (click)="screenCheck($event, r, i, j)"
                                                        [checked]="screenPrivilegeList.isChecked">
                                                </th>
                                                <th>{{screenPrivilegeList.name}}</th>
                                                <th>{{screenPrivilegeList.description}}</th>
                                                <th>
                                                    <div class="permissions">
                                                        <p>
                                                            <input type="checkbox"
                                                                [(ngModel)]="screenPrivilegeList.view"
                                                                [ngModelOptions]="{standalone: true}">
                                                            {{ 'roles.view' | translate }}
                                                        </p>
                                                        <p [ngClass]="{'no-access': !screenPrivilegeList.isAdd}">
                                                            <input type="checkbox" [(ngModel)]="screenPrivilegeList.add"
                                                                [ngModelOptions]="{standalone: true}">
                                                            {{ 'roles.add' | translate }}
                                                        </p>
                                                        <p [ngClass]="{'no-access': !screenPrivilegeList.isModify}">
                                                            <input type="checkbox"
                                                                [(ngModel)]="screenPrivilegeList.modify"
                                                                [ngModelOptions]="{standalone: true}">
                                                            {{ 'roles.modify' | translate }}
                                                        </p>
                                                        <p [ngClass]="{'no-access': !screenPrivilegeList.isDelete}">
                                                            <input type="checkbox"
                                                                [(ngModel)]="screenPrivilegeList.delete"
                                                                [ngModelOptions]="{standalone: true}">
                                                            {{ 'roles.delete' | translate }}
                                                        </p>
                                                        <p [ngClass]="{'no-access': !screenPrivilegeList.isVerify}">
                                                            <input type="checkbox"
                                                                [(ngModel)]="screenPrivilegeList.verify"
                                                                [ngModelOptions]="{standalone: true}">
                                                            {{ 'roles.verify' | translate }}
                                                        </p>
                                                        <p [ngClass]="{'no-access': !screenPrivilegeList.isApprove}">
                                                            <input type="checkbox"
                                                                [(ngModel)]="screenPrivilegeList.approve"
                                                                [ngModelOptions]="{standalone: true}">
                                                            {{ 'roles.approve' | translate }}
                                                        </p>
                                                        <p [ngClass]="{'no-access': !screenPrivilegeList.isIssue}">
                                                            <input type="checkbox"
                                                                [(ngModel)]="screenPrivilegeList.issue"
                                                                [ngModelOptions]="{standalone: true}">
                                                            {{ 'roles.issue' | translate }}
                                                        </p>
                                                        <p [ngClass]="{'no-access': !screenPrivilegeList.isAttach}">
                                                            <input type="checkbox"
                                                                [(ngModel)]="screenPrivilegeList.attach"
                                                                [ngModelOptions]="{standalone: true}">
                                                            {{ 'roles.attach' | translate }}
                                                        </p>
                                                        <p [ngClass]="{'no-access': !screenPrivilegeList.isRemove}">
                                                            <input type="checkbox"
                                                                [(ngModel)]="screenPrivilegeList.remove"
                                                                [ngModelOptions]="{standalone: true}">
                                                            {{ 'roles.remove' | translate }}
                                                        </p>
                                                    </div>
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="roleClose" (click)="deleteClose()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="addRoleToUser()" *ngIf="buttonDisable == false"
                        class="btn btn-primary">{{ 'generic.add' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="updateRole" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Update Role
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <div class="row" *ngFor="let role of userPrivileges;">
                        <div class="col-md-12 col-lg-12">
                            <label>Role Name</label>
                            <input type="text" class="form-control">
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <div class="singleData"
                                *ngFor="let rolePrevilage of role.rolePrevilages;let i = index;let last = last;let first = first">
                                <div class="single-role-header">
                                    <label>{{rolePrevilage.groupName}}</label>
                                    <span>
                                        <i (click)="privilegeAdjust(i,'up')" *ngIf="!first" class="bi bi-arrow-up"></i>
                                        <i (click)="privilegeAdjust(i,'down')" *ngIf="!last"
                                            class="bi bi-arrow-down"></i>
                                    </span>
                                </div>
                                <div class="single-role-table">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <!-- <th style="width: 5%;">S.No.</th> -->
                                                <th style="width: 30%;">Name</th>
                                                <th style="width: 45%;">Description</th>
                                                <th style="width: 15%;">Position</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                *ngFor="let screenPrivilegeList of rolePrevilage.screenPrivilegeList;let j = index;let jlast = last;let jfirst = first">
                                                <!-- <th>{{screenPrivilegeList.seqNo}}</th> -->
                                                <th>{{screenPrivilegeList.name}}</th>
                                                <th>{{screenPrivilegeList.description}}</th>
                                                <th class="position-arrows">
                                                    <span>
                                                        <button (click)="screenPrivilegeListAdjust(i,j,'up')"
                                                            *ngIf="!jfirst">up</button>
                                                        <button (click)="screenPrivilegeListAdjust(i,j,'down')"
                                                            *ngIf="!jlast">down</button>
                                                        <!-- 
                                                        <i (click)="screenPrivilegeListAdjust(i,j,'up')" *ngIf="!jfirst" class="bi bi-arrow-up"></i>
                                                        <i (click)="screenPrivilegeListAdjust(i,j,'down')" *ngIf="!jlast" class="bi bi-arrow-down"></i> -->
                                                    </span>
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" id="closeModalButton" class="btn btn-secondary"
                            data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" (click)="updatePosition()">save changes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="passwordPromptModal" tabindex="-1" data-backdrop="static"
    aria-labelledby="passwordPromptModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="passwordPromptModalLabel">Authentication <i class="bi bi-x-lg"
                        data-dismiss="modal"></i>
                </h5>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label>Please enter your password to register TPM:</label>
                    <input type="password" class="form-control" [(ngModel)]="registrarPassword">
                </div>
                <div class="modal-footer ">
                    <div class="buttons">
                        <button type="button" id="closePasswordPromptButton" class="btn btn-secondary"
                            data-dismiss="modal">Cancel</button>
                        <button type="button" (click)="registerOtp()" class="btn btn-success">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>